import React, { useEffect, useState } from "react";
import { MdLanguage } from "react-icons/md";
import { NavDropdown } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import { languages } from "../../../i18n/i18n";
import "./LanguageSwitcher.scss";
import Cookies from "js-cookie";

type Props = {
  onChange: (key: string) => void;
};

/**
 * Renders a dropdown component with the available languages
 * @param onChange handle language switch
 * @constructor
 */
export function LanguageSwitcher({ onChange }: Props) {
  const { i18n } = useTranslation();
  const [selectedKey, setSelectedKey] = useState<string>(
    i18n.language);

  // Update selectedKey state on language change
  useEffect(() => {
    setSelectedKey(i18n.language);
  }, [i18n.language]);

  const handleLanguageChange = (key: string) => {
    onChange(key);
    Cookies.set("selectedLanguage", key, { expires: 365 });
    setSelectedKey(key);
  };

  return (
    <NavDropdown id="languageDropdown" title={<MdLanguage className="icon" />}>
      {Object.keys(languages).map((key) => (
        <NavDropdown.Item
          key={key}
          active={selectedKey === key}
          onClick={() => handleLanguageChange(key)}
        >
          {languages[key].name}
        </NavDropdown.Item>
      ))}
    </NavDropdown>
  );
}
